import { jsx as _jsx } from "react/jsx-runtime";
export function EmailIcon(props) {
    return (_jsx("svg", { width: '32', height: '32', viewBox: '0 0 32 32', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M10.3125 12.5V20.375H21.6875V12.5H10.3125ZM12.1992 13.375H19.8008L16 15.9043L12.1992 13.375ZM11.1875 13.7578L15.7539 16.8066L16 16.957L16.2461 16.8066L20.8125 13.7578V19.5H11.1875V13.7578Z', fill: 'currentColor' }) }));
}
